import { render, staticRenderFns } from "./PlayerSelection.vue?vue&type=template&id=079270b9&scoped=true&"
import script from "./PlayerSelection.vue?vue&type=script&lang=js&"
export * from "./PlayerSelection.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSelection.vue?vue&type=style&index=0&id=079270b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079270b9",
  null
  
)

export default component.exports